const {PUBLIC_ORIGIN}=require('../config/publicSite');
const PLAY_URL=PUBLIC_ORIGIN+'/';
const INVITATION_TEXT='Kelimo’da kelimelerini kur, rakibinle yarış. Sen de oyna:';
function invitationData(){return {title:'Kelimo',text:INVITATION_TEXT,url:PLAY_URL};}
module.exports={PLAY_URL,INVITATION_TEXT,invitationData};
